import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs/operators';

import { DevicesRouterStoreSelectors } from '../router';

import { Observable } from 'rxjs';
import { DevicesOsUpdateStatusActions } from './index';

@Injectable({ providedIn: 'root' })
export class DeviceOsUpdateStatusResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (udid) {
          this.store.dispatch(
            DevicesOsUpdateStatusActions.DeviceOsUpdateStatesResolverActions.osUpdateStateRequested({
              udid: udid,
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
